import type { Language } from '../../stores/app-store';

export interface SystemLanguage {
  code: Language;
  combinedName: string;
  englishName: string;
  nativeName: string;
  isRTL: boolean;
  sortOrder: number;
}

// All language codes that have translation files bundled in this build.
// Used to filter backend results — only codes present here will be shown.
// This includes codes that may currently be disabled in the backend (e.g. ckb).
const ALL_BUNDLED_LOCALE_CODES = new Set<Language>(['en', 'es', 'ar', 'fa', 'ku', 'ckb', 'ro']);
export const BUNDLED_SYSTEM_LANGUAGE_CODES: Language[] = ['en', 'es', 'ar', 'fa', 'ku', 'ckb', 'ro'];

export function isBundledSystemLanguage(code: string): code is Language {
  return ALL_BUNDLED_LOCALE_CODES.has(code as Language);
}

// Fallback list shown when the backend is unreachable.
// Must only contain languages that are currently active in the backend
// (i.e. is_system_lang = true) so the offline fallback matches the intended UX.
export const BUNDLED_SYSTEM_LANGUAGES: SystemLanguage[] = [
  { code: 'en', combinedName: 'English (English)', englishName: 'English', nativeName: 'English', isRTL: false, sortOrder: 10 },
  { code: 'es', combinedName: 'Spanish (Español)', englishName: 'Spanish', nativeName: 'Español', isRTL: false, sortOrder: 20 },
  { code: 'ar', combinedName: 'Arabic (العربية)', englishName: 'Arabic', nativeName: 'العربية', isRTL: true, sortOrder: 30 },
  { code: 'fa', combinedName: 'Persian (فارسی)', englishName: 'Persian', nativeName: 'فارسی', isRTL: true, sortOrder: 40 },
  { code: 'ku', combinedName: 'Kurdish (Kurmanji) (Kurdî Kurmancî)', englishName: 'Kurdish (Kurmanji)', nativeName: 'Kurdî Kurmancî', isRTL: false, sortOrder: 50 },
  { code: 'ro', combinedName: 'Romanian (Română)', englishName: 'Romanian', nativeName: 'Română', isRTL: false, sortOrder: 70 },
];

export function getBundledSystemLanguages(): SystemLanguage[] {
  return BUNDLED_SYSTEM_LANGUAGES;
}
